import { useSelector } from 'react-redux';
import { patchOrgAttributes } from '@rsos/sinatra/src/actions/updateAttributes';
import { useCurrentOrg } from '@rsos/sinatra/src/selectors';
import { selectFollowUpReplyNotifications } from '@rsos/sinatra/src/selectors/selectFollowUpReplyNotifications';
import { CapstoneFollowUpReplyNotifications } from '@rsos/sinatra/src/types/Organization';

/**
 * `usePatchAudioSettings` cannot be reused: it hard-codes the `audio_settings`
 * attribute key, and banners are not audio.
 */
export const usePatchFollowUpReplyNotifications = () => {
  const orgId = useCurrentOrg()?.id;
  const currentSettings = useSelector(selectFollowUpReplyNotifications);
  return (update: Partial<CapstoneFollowUpReplyNotifications>) => {
    if (!orgId) {
      throw new Error(
        'Cannot patch follow-up reply notifications without a current organization',
      );
    }
    return patchOrgAttributes(orgId, 'capstone', {
      follow_up_reply_notifications: { ...currentSettings, ...update },
    });
  };
};
